var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uni-empty" }, [
    _c("img", {
      staticClass: "empty-img",
      class: _vm.imgClass,
      attrs: { src: require("../assets/images/empty.png"), alt: "" },
    }),
    _c("p", { staticClass: "p1" }, [_vm._v(_vm._s(_vm.title))]),
    _c("p", { staticClass: "p2" }, [_vm._v(_vm._s(_vm.tips))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }